import { LanguagesIsoEnum } from "@/modules/assessments/types/test.interface";

export enum LocaleUrlType {
  TermsOfService = "termsOfService",
  Attestation = "attestation",
}

type LocaleUrls = Record<LocaleUrlType, string | undefined>;

// External URLs per locale, sourced from env vars so they can vary per environment.
// Add a language by adding a row here (and its env vars); English is the default fallback.
const LOCALE_URL_CONFIG: { [locale in LanguagesIsoEnum]?: LocaleUrls } = {
  [LanguagesIsoEnum.enUS]: {
    [LocaleUrlType.TermsOfService]: process.env.REACT_APP_TERMS_OF_SERVICE_URL,
    [LocaleUrlType.Attestation]: process.env.REACT_APP_ATTESTATION_URL,
  },
  [LanguagesIsoEnum.esUS]: {
    [LocaleUrlType.TermsOfService]: process.env.REACT_APP_TERMS_OF_SERVICE_URL_ES,
    [LocaleUrlType.Attestation]: process.env.REACT_APP_ATTESTATION_URL_ES,
  },
};

// Falls back to English when the locale is unknown or its URL isn't configured (incl. blank env vars).
export function getLocalizedUrl(urlType: LocaleUrlType, locale: string | null | undefined): string | undefined {
  const localizedUrl = LOCALE_URL_CONFIG[locale as LanguagesIsoEnum]?.[urlType];
  return localizedUrl || LOCALE_URL_CONFIG[LanguagesIsoEnum.enUS]?.[urlType];
}
